import { render, staticRenderFns } from "./CommunityQnaDetail.vue?vue&type=template&id=54270050&scoped=true"
import script from "./CommunityQnaDetail.vue?vue&type=script&lang=js"
export * from "./CommunityQnaDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityQnaDetail.vue?vue&type=style&index=0&id=54270050&prod&scoped=true&lang=css"
import style1 from "./CommunityQnaDetail.vue?vue&type=style&index=1&id=54270050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54270050",
  null
  
)

export default component.exports